export const selectTwoFaMobileDomain = () => (state) => state.twoFaMobile;
